import React from 'react';
import PrintRow from "./print-row.jsx";
import PrintImage from "./print-image.jsx";

const PrintBody = ({passages}) => {
    return (
        <table className="min-w-full [&_:is(td,th)]:py-1!">
            <tbody>
                {passages.map((passage, index) => (
                    <tr key={index} className="bg-white border-b border-gray-300 print:break-inside-avoid">
                        <td className="py-1 align-top">
                            <table className="[&_:is(td,th)]:py-2.5!">
                                <tbody className="[&>tr:nth-child(odd)]:bg-black/5">
                                    <PrintRow title={"Placa"} value={passage.plate.value.replace(/(\w{3})(\w{4})/, "$1-$2")} plate={true}/>
                                    <PrintRow title={"Data/Hora"} value={passage.captureTime}/>
                                    <PrintRow title={"Local"} value={passage?.lane.name} place={true}/>
                                </tbody>
                            </table>
                        </td>
                        <PrintImage image={passage.printImageSrc ?? passage.imageUrl} status={passage.printImageStatus} />
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default PrintBody;